var _path, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50764 5.5C8.50764 4 7.79902 1.5 7.0076 1.5C6.0076 1.5 4.67399 4.5 4.00734 6.5C3.3749 8.39737 2.00767 11 2.50764 14.5C3.07328 18.4598 6.5076 21 10.5076 21.5C15.5672 22.1325 19.2038 20.9115 20.5076 17C22.0076 12.5 21.5076 6.5 21.0076 6C20.5076 5.5 18.5076 7.5 15.5076 8C12.5076 8.5 10.5076 7 9.50764 5.5Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 3,
    fill: "white",
    stroke: "#5E5E5E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 1,
    fill: "#5E5E5E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 12.5,
    r: 3.5,
    fill: "white",
    stroke: "#5E5E5E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 12.5,
    r: 1,
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits);
export default __webpack_public_path__ + "static/media/benefits.2dea0cd70bcdcf8d4f493369e26c32c7.svg";
export { ForwardRef as ReactComponent };